import {
  RadiusParserOptionsState,
  RadiusParserOptionsActionTypes,
  GET_RADIUS_PARSER_OPTIONS_PENDING,
  GET_RADIUS_PARSER_OPTIONS_FULFILLED,
  SET_RADIUS_PARSER_OPTIONS_LOADING,
  CREATE_RADIUS_PARSER_OPTIONS,
  UPDATE_RADIUS_PARSER_OPTIONS_FULFILLED,
  UPDATE_RADIUS_PARSER_OPTIONS_REJECTED,
  UPDATE_RADIUS_PARSER_OPTIONS_PENDING,
  UPDATE_RADIUS_PARSER_OPTIONS
} from './radiusParserOptions.types';

export const initialState: RadiusParserOptionsState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
    isSaving: false,
  }
};

export default function dialedDigitExtractionServerReducer(
  state = initialState,
  action: RadiusParserOptionsActionTypes,
): RadiusParserOptionsState {
  switch (action.type) {

    case GET_RADIUS_PARSER_OPTIONS_PENDING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: true,
        }
      };

    case GET_RADIUS_PARSER_OPTIONS_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
        ui: {
          ...state.ui,
          isLoading: false,
        }
      };

    case SET_RADIUS_PARSER_OPTIONS_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    case CREATE_RADIUS_PARSER_OPTIONS:
      return {
        ...state,
        ui: {
          ...state.ui,
        },
      };

    case UPDATE_RADIUS_PARSER_OPTIONS:
      return {
        ...state,
        ui: {
          ...state.ui,
          isSaving: true,
        },
      };

    case UPDATE_RADIUS_PARSER_OPTIONS_PENDING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isSaving: true,
        },
      };

    case UPDATE_RADIUS_PARSER_OPTIONS_FULFILLED:
        return {
          ...state,
          ui: {
            ...state.ui,
            isSaving: false,
          },
        };

    case UPDATE_RADIUS_PARSER_OPTIONS_REJECTED:
      return {
        ...state,
        ui: {
          ...state.ui,
          isSaving: false,
        },
      };
    default:
      return state;
  }
}
